var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 52 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-760.303,-1665.61)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,129.303,-116)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "facebook",
    transform: "matrix(3.24408,0,0,3.24408,631.006,1781.61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,8.049C16,3.603 12.418,-0.001 8,-0.001C3.58,0 -0.002,3.603 -0.002,8.05C-0.002,12.067 2.924,15.397 6.748,16.001L6.748,10.376L4.718,10.376L4.718,8.05L6.75,8.05L6.75,6.275C6.75,4.258 7.945,3.144 9.772,3.144C10.648,3.144 11.563,3.301 11.563,3.301L11.563,5.281L10.554,5.281C9.561,5.281 9.251,5.902 9.251,6.539L9.251,8.049L11.469,8.049L11.115,10.375L9.25,10.375L9.25,16C13.074,15.396 16,12.066 16,8.049Z",
    style: {
      fill: "rgb(247,242,238)",
      fillRule: "nonzero"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialFacebook);
export default __webpack_public_path__ + "static/media/social-facebook.207e05bcc427eb6d69ad28883c219d3f.svg";
export { ForwardRef as ReactComponent };